import { render } from "./domainLevel.vue?vue&type=template&id=24200332&scoped=true"
import script from "./domainLevel.vue?vue&type=script&lang=js"
export * from "./domainLevel.vue?vue&type=script&lang=js"

import "./domainLevel.vue?vue&type=style&index=0&id=24200332&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24200332"]])

export default __exports__